import SideMenu from '@/containers/side-menu/SideMenu.vue';
import Clients from '@/pages/clients/Clients.vue';

export default {
  path: '/clients',
  name: 'Clients',
  components: {
    mainContent: Clients,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'add-client',
    },
    breadcrumb: {
      title: 'Configurações',
      paths: [{ title: 'Clientes' }],
    },
  },
};
